import { StoryNode } from "../CommonUI/StoryBook/StoryData";
import React from "react";
import { TextMergeBuilder } from "./TextMergeBuilder";
import { TextSubstitutionEditor } from "./TextSubsitution/TextSubstitutionEditor";
import { getFilledDataDefinition } from "../CommonUI/DataEditing/Testing/TestData";
import { TextMergeConfiguration } from "../rule-engine-core/TextMerge/TextMergeConfiguration";
import { TextMergeType } from "../rule-engine-core/TextMerge/TextMergeType";
import { TextElement } from "../rule-engine-core/TextMerge/Elements/Text/TextElement";
import { TextSubstitutionConfiguration } from "../rule-engine-core/TextMerge/TextSubstitutionConfiguration";
import { FieldElement } from "../rule-engine-core/TextMerge/Elements/Text/FieldElement";
import { LineBreakElement } from "../rule-engine-core/TextMerge/Elements/Text/LineBreakElement";
import { StyleElement } from "../rule-engine-core/TextMerge/Elements/Text/StyleElement";
import { JSONXMLStringElement } from "../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLStringElement";
import { JSONXMLBuildObjectElement } from "../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLBuildObjectElement";
import { XMLAttributeElement } from "../rule-engine-core/TextMerge/Elements/JSONXML/XMLAttributeElement";

function getConfig(): TextMergeConfiguration {
    const textMerge = new TextMergeConfiguration();

    textMerge.rootElement.addElement(new TextElement("Hi "));
    textMerge.rootElement.addElement(new FieldElement("name"));
    textMerge.rootElement.addElement(new LineBreakElement());

    let styleElement = new StyleElement();
    styleElement.bold = true;
    styleElement.fontColor = "red";

    styleElement.addElement(new TextElement("you are late on your project"));
    styleElement.addElement(new FieldElement("project"));
    styleElement.addElement(new TextElement("as of today"));

    textMerge.rootElement.addElement(styleElement);

    textMerge.rootElement.addElement(new LineBreakElement());

    textMerge.rootElement.addElement(new TextElement("please finish or contact "));
    textMerge.rootElement.addElement(new FieldElement("contactperson"));
    textMerge.rootElement.addElement(new TextElement("at"));
    textMerge.rootElement.addElement(new FieldElement("contactemail"));

    textMerge.inputData = getFilledDataDefinition();

    return textMerge;
}

function getSubConfig(): TextSubstitutionConfiguration {
    let config = new TextSubstitutionConfiguration();
    config.text = "this [!subject!] is about [!about!].  I [!emotion!] [!subject!]";

    config.inputData = getFilledDataDefinition();

    return config;
}

export const CustomTextMergeBuilder = [
    new StoryNode(
        () => {
            let config = getConfig();
            config.type = TextMergeType.HTML;
            return <TextMergeBuilder definition={config} />;
        },
        "Text Merge Builder",
        "HTML",
    ),
    new StoryNode(
        () => {
            let config = new TextMergeConfiguration();
            config.inputData = getFilledDataDefinition();
            config.type = TextMergeType.PlAIN;

            return <TextMergeBuilder definition={config} />;
        },
        "Text Merge Builder",
        "Plain Text",
    ),
    new StoryNode(
        () => {
            let config = new TextMergeConfiguration();
            config.inputData = getFilledDataDefinition();
            config.type = TextMergeType.MULTI_LINE;
            return <TextMergeBuilder definition={config} />;
        },
        "Text Merge Builder",
        "Multi Line Text",
    ),
    new StoryNode(
        () => {
            let config = getSubConfig();

            return <TextSubstitutionEditor config={config} />;
        },
        "Text Merge Builder",
        "Substitution",
    ),
    new StoryNode(
        () => {
            let config = new TextMergeConfiguration();
            config.rootElement.addElement(new JSONXMLStringElement("firstName"));
            config.rootElement.addElement(new JSONXMLStringElement("lastName"));

            let addEl = new JSONXMLBuildObjectElement("addresss");
            addEl.addElement(new JSONXMLStringElement("city"));
            addEl.addElement(new JSONXMLStringElement("state"));

            config.rootElement.addElement(addEl);

            config.inputData = getFilledDataDefinition();
            config.type = TextMergeType.JSON;
            return <TextMergeBuilder definition={config} />;
        },
        "Text Merge Builder",
        "JSON",
    ),
    new StoryNode(
        () => {
            let config = new TextMergeConfiguration();
            let attEl = new XMLAttributeElement();
            attEl.addElement(new JSONXMLStringElement("id"));

            config.rootElement.addElement(attEl);

            config.rootElement.addElement(new JSONXMLStringElement("firstName"));
            config.rootElement.addElement(new JSONXMLStringElement("lastName"));

            let addEl = new JSONXMLBuildObjectElement("addresss");
            addEl.addElement(new JSONXMLStringElement("city"));
            addEl.addElement(new JSONXMLStringElement("state"));

            config.rootElement.addElement(addEl);
            config.inputData = getFilledDataDefinition();
            config.type = TextMergeType.XML;
            return <TextMergeBuilder definition={config} />;
        },
        "Text Merge Builder",
        "XML",
    ),
];
